import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { CMSPlaceInitStepDeclaration } from "./Steps/FamousPlaceInitStep";

export const CMSPlaceStartupFlow = new FlowDefinition("CMSPlaceFlow");

CMSPlaceStartupFlow.addStep(CMSPlaceInitStepDeclaration);

CMSPlaceStartupFlow.setStartStep("CMSPlaceInit_Step");

export const CMSPlaceStartupStepDefinition = new StepDefinition({
    stepName: "CMSPlaceFlow",
    stepFlow: CMSPlaceStartupFlow,
    contextIsolation: false
})